import React from 'react';

export default function StatsTab({ match }) {
  const stats = match.stats;

  if (!stats || stats.length === 0) {
    return (
      <div className="tab-empty">
        <p>Stats not available yet.</p>
        <p className="tab-empty-sub">Match hasn't started.</p>
      </div>
    );
  }

  return (
    <div className="stats-list">
      {stats.map((s, i) => {
        const homeNum = parseFloat(s.home);
        const awayNum = parseFloat(s.away);
        const total = homeNum + awayNum || 1;
        const homePct = (homeNum / total) * 100;
        const awayPct = (awayNum / total) * 100;
        const homeWins = homeNum > awayNum;
        const awayWins = awayNum > homeNum;

        return (
          <div key={i} className="stat-row">
            <div className={`stat-value home ${homeWins ? 'winning' : ''}`}>
              {s.home}{s.unit || ''}
            </div>
            <div className="stat-bar-wrap">
              <div className="stat-label">{s.label}</div>
              <div className="stat-bar">
                <div className="stat-bar-home" style={{ width: `${homePct}%` }}></div>
                <div className="stat-bar-away" style={{ width: `${awayPct}%` }}></div>
              </div>
            </div>
            <div className={`stat-value away ${awayWins ? 'winning' : ''}`}>
              {s.away}{s.unit || ''}
            </div>
          </div>
        );
      })}
    </div>
  );
}
